import createDetailsSelector from './createDetailsSelector';
import { getOutputData } from '../getOutputData';
import { getOutputAlarmRanges } from '../getOutputAlarmRanges';
import { getOutputProperties } from '../getOutputProperties';

export default createDetailsSelector(getOutputData, getOutputAlarmRanges, getOutputProperties);